import config from 'config';

const BASE_URL = 'https://maps.googleapis.com/maps/api/js';
const libraries = ['geometry'];
let promise = null;

const buildScriptUrl = (version = '3.55') => {
  return [
    BASE_URL,
    `?callback=Function.prototype&key=${config.GOOGLE_MAPS_API_KEY}`,
    `&v=${version}`,
    libraries ? `&libraries=${libraries.join(',')}` : '',
  ].join('');
};

const loadGoogleMaps = () => {
  const id = 'google-maps-script';
  const $scriptTag = document.querySelector(id);

  if ($scriptTag) {
    return Promise.resolve(window.google.maps);
  }

  if (promise) {
    return promise;
  }

  promise = new Promise((resolve) => {
    const scriptUrl = buildScriptUrl();
    const scriptTag = document.createElement('script');

    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.src = scriptUrl;
    scriptTag.id = id;

    document.body.appendChild(scriptTag);

    scriptTag.addEventListener('load', () => {
      resolve(window.google.maps);
    });
  });

  return promise;
};

export default loadGoogleMaps;
